import { getAuthContext } from '../context/AuthContext';

const getAxios = () => getAuthContext().axiosInstance;

const resolveEmpresaId = async () => {
    const { user } = getAuthContext();

    if (user?.idEmpresa) {
        return user.idEmpresa;
    }

    if (user?.idSucursal) {
        const sucursalResponse = await getAxios().get(`/api/sucursales/${user.idSucursal}`);
        return sucursalResponse.data?.data?.idEmpresa ?? 1;
    }

    return 1;
};

export const ProductoService = {
    getAll: async () => {
        const idEmpresa = await resolveEmpresaId();
        const response = await getAxios().get(`/api/productos/empresa/${idEmpresa}`);
        return response.data;
    },
    
    getById: async (id) => {
        const response = await getAxios().get(`/api/productos/${id}`);
        return response.data;
    },

    create: async (producto) => {
        const response = await getAxios().post('/api/productos', producto);
        return response.data;
    },

    update: async (id, producto) => {
        const response = await getAxios().put(`/api/productos/${id}`, producto);
        return response.data;
    },

    delete: async (id) => {
        const response = await getAxios().delete(`/api/productos/${id}`);
        return response.data;
    },
    
    uploadImage: async (file, identifier = 'general') => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('identifier', identifier);
        const response = await getAxios().post('/api/productos/imagen', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    },

    deleteImage: async (url) => {
        const response = await getAxios().delete('/api/productos/imagen', { params: { url } });
        return response.data;
    }
};
